import React from 'react';
import PropTypes from 'prop-types';
import {formatMoney} from '@shopify/theme-currency';

import {imageUrl} from '../../../../assets/scripts/utils/shopify-images';
import iconBin from '../../../../assets/svg/icon-bin.svg';
import iconPlus from '../../../../assets/svg/icon-plus.svg';

const GiftWithPurchase = ({item, gwpStatus, cartItems, setGwpManuallyRemoved, addToCart, updateLineItems}) => {
  const {isInCart, isEligible, remainingSpend} = gwpStatus;

  const minimumSpend = item.minimum_spend ?? 0;

  const barPercentage = isEligible ? 100 : Math.max(0, ((minimumSpend - remainingSpend) / minimumSpend) * 100);

  const barWidth = {
    width: `${barPercentage}%`,
  };

  const barMessageString = window.theme?.string?.giftWithPurchase?.remaining ?? 'You are {{ amount }} away';
  const barMessage = isEligible
    ? ''
    : barMessageString.replace('{{ amount }}', formatMoney(remainingSpend, window.theme.moneyFormat));

  const handleGwpRemove = () => {
    const gwpCartItem = cartItems.find(
      (cartItem) => cartItem.id === item.currentVariant.id && cartItem.properties?._gwp
    );
    if (!gwpCartItem) return;

    updateLineItems({[gwpCartItem.key]: 0});

    setGwpManuallyRemoved(true);
    sessionStorage.setItem('gwpManuallyRemoved', true);
  };

  const handleGwpAdd = () => {
    addToCart({
      id: item.currentVariant.id,
      quantity: 1,
      properties: {
        _gwp: true,
      },
    });

    setGwpManuallyRemoved(false);
    sessionStorage.removeItem('gwpManuallyRemoved');
  };

  return (
    <div className="cart__gwp">
      <div className="cart__gwp-bar">
        <div className="cart__gwp-bar-progress" style={barWidth} />
      </div>
      <div className="cart__gwp-item cart-item">
        <div className="cart__gwp-content cart-item__content">
          {barMessage && <p className="cart__gwp-text cart__gwp-text--highlight">{barMessage}</p>}
          <p className="cart__gwp-text cart__gwp-text--highlight">
            {window.theme?.string?.giftWithPurchase?.label ?? 'Free Gift'}
          </p>
          <p className="cart__gwp-title">{item.title.split(' - ')[0]}</p>
          {item.currentVariant && item.currentVariant.title && item.currentVariant.title !== 'Default Title' && (
            <p className="cart__gwp-variant">{item.currentVariant.title}</p>
          )}

          {isInCart && (
            <button
              className="cart__gwp-btn cart__gwp-remove btn-none"
              type="button"
              aria-label="Remove from cart"
              onClick={handleGwpRemove}
            >
              <span dangerouslySetInnerHTML={{__html: iconBin}} />
            </button>
          )}

          {isEligible && !isInCart && (
            <button className="cart__gwp-btn cart__gwp-add btn--icon btn-none" type="button" onClick={handleGwpAdd}>
              Add <span dangerouslySetInnerHTML={{__html: iconPlus}} />
            </button>
          )}
        </div>

        {item.featured_image && (
          <div className="cart__gwp-image cart-item__image">
            <div className="aspect-ratio aspect-ratio--portrait">
              <img
                src={imageUrl(item.featured_image, 180, 240, 'center')}
                width={90}
                height={120}
                alt={item.title}
                loading="lazy"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

GiftWithPurchase.propTypes = {
  item: PropTypes.object,
  gwpStatus: PropTypes.object,
  cartItems: PropTypes.arrayOf(PropTypes.object),
  setGwpManuallyRemoved: PropTypes.func,
  addToCart: PropTypes.func,
  updateLineItems: PropTypes.func,
};

export default GiftWithPurchase;
